import { HeritageRegister, HeritageRegisterApiException, Result, ParcelsResponse } from './HeritageRegister';
import NotificationUtil from './_notificationUtil';

let client: HeritageRegister = null;

function getHeritageRegisterClient() {
    return client || (client = new HeritageRegister(window.ETDR_RD.appConfig['Settings.HeritageRegisterServerAddress']));
}

function getCacheKey(settlement: string, parcel: string): string {
    return `pp-${settlement}-${parcel}`;
}

async function getParcelProtectionFromAPI(settlement: string, parcel: string): Promise<Result[]> {
    let errorText: string = 'Az ingatlan lekérdezése az örökségvédelmi nyilvántartásból sikertelen';

    try {
        let parcels: ParcelsResponse = await getHeritageRegisterClient().parcels(settlement, parcel);

        if (parcels.success) {
            sessionStorage.setItem(getCacheKey(settlement, parcel), JSON.stringify(parcels.result));
            return parcels.result;
        }
        else {
            NotificationUtil.Error(errorText);
        }
    } catch (err) {
        if (err instanceof HeritageRegisterApiException) {
            NotificationUtil.Error(err.message);
            return;
        } else {
            NotificationUtil.Error(errorText);
        }
    }
}

function getParcelProtectionFromSessionStorage(settlement: string, parcel: string): Result[] {
    let cachedData = sessionStorage.getItem(getCacheKey(settlement, parcel));

    if (!cachedData) {
        return null;
    }

    return JSON.parse(cachedData) as Result[];
}

export async function getParcelProtection(settlement: string, parcel: string): Promise<Result[]> {
    return getParcelProtectionFromSessionStorage(settlement, parcel) || getParcelProtectionFromAPI(settlement, parcel);
}

export function initParcelProtectionStatus(s: MVCxClientGridView, e: ASPxClientEventArgs) {
    for (let i = 0; i < s.GetVisibleRowsOnPage(); ++i) {
        let wrapperElement = $(`[data-visible-index="${i}"]`);

        if (!wrapperElement || wrapperElement.length === 0) {
            continue;
        }

        let settlement = wrapperElement.data('settlement');
        let parcel = wrapperElement.data('parcel');

        getParcelProtection(settlement, parcel).then(protections => {
            wrapperElement.empty();

            if (!protections || protections.length == 0) {
                wrapperElement.append('<span>Az IVO szerint az ingatlannak nincs örökségvédelmi érintettsége.</span>');
            }
            else {
                wrapperElement.append('<span>Az IVO szerint az ingatlannak az alábbi örökségvédelmi érintettsége van</span>');

                protections.forEach(protection => {

                    let parcelProtectionTemplate = document.getElementById('template-parcel-protection') as HTMLTemplateElement;
                    let clonedElement = $(parcelProtectionTemplate.content.cloneNode(true)) as JQuery<HTMLDivElement>;

                    let labelElement = clonedElement.find('legend');
                    let textElements = clonedElement.find('span');

                    labelElement.text(`${protection.settlement} (${protection.parcel})`);
                    textElements.text(protection.protection.join(', '));

                    wrapperElement.append(clonedElement);
                });
            }
        });
    }
}

export function initParcelProtectionStatusForProcess(s: MVCxClientPageControl, e: ASPxClientEventArgs) {
    $('[data-parcel-protection]').each((_: number, e: HTMLElement) => {
        let elem = $(e);

        let settlement = elem.data('settlement');
        let parcel = elem.data('parcel');

        getParcelProtection(settlement, parcel).then(protections => {
            if (protections && protections.length > 0) {
                let subjectEstatesTabDomElement = $('.dxtc-tab.subjectEstatesTabMarker');
                subjectEstatesTabDomElement.addClass('bg-yellow-light');

                let heritageIcon = $('#processHeaderRow');
                heritageIcon.removeClass('hide-before-pseudo-element');
            }
        });
    });
}
